import cn from 'classnames';
import { EngineTheme } from '@websky/core/src/theme';

import * as Inner from './components/Inner/Inner.css';
import * as Results from './components/Results/Results.css';
import * as SearchForm from './components/SearchForm/SearchForm.css';
import * as Stepbar from './components/Stepbar/Stepbar.css';
import * as Toolbar from './components/Toolbar/Toolbar.css';
import * as Meal from './components/Meal/Meal.css';
import * as ActionButton from './components/ActionButton/ActionButton.css';
import * as Counter from './components/Counter/Counter.css';
import * as Baggage from './components/Baggage/Baggage.css';
import * as SeatMap from './components/SeatMap/SeatMap.css';
import * as Link from './components/Link/Link.css';
import * as Exare from './components/Exare/Exare.css';
import * as Checkout from './components/Checkout/Checkout.css';
import * as OrderCard from './components/OrderCard/OrderCard.css';
import * as PromoLoader from './components/PromoLoader/PromoLoader.css';
import * as CompareFares from './components/CompareFares/CompareFares.css';
import * as DesktopFlightModalContent from './components/DesktopFlightModalContent/DesktopFlithModalContent.css';
import * as Checkin from './components/Checkin/Checkin.css';
import * as Insurance from './components/Insurance/Insurance.css';
import * as PaymentTimeLimit from './components/PaymentTimeLimit/PaymentTimeLimit.css';
import * as MobileSegmentInfo from './components/MobileSegmentInfo/MobileSegmentInfo.css';
import * as Payment from './components/Payment/Payment.css';
import * as PassengerToolbarAdditional from '../components/Checkout/PassengerToolbar/PassengerToolbarAdditional.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import MobileSelectedFare from './components/MobileSelectedFare/MobileSelectedFare.css';
import Cart from './components/Cart.css';
import Modal from './components/Modal/Modal.css';
import QuickSearchForm from './components/QuickSearchForm/Summary/Summary.css';
import Notification from './components/Notification/Notification.css';
import AdditionalServiceBanner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import IncludedBaggage from './components/Baggage/IncludedBaggage/IncludedBaggage.css';
import AdditionalBaggage from './components/Baggage/AdditionalBaggage/AdditionalBaggage.css';
import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon.css';
import BaggageDirection from './components/Baggage/BaggageList/BaggageDirection/BaggageDirection.css';
import BaggageCard from './components/Baggage/BaggageCard/BaggageCard.css';
import ResendTicketsForm from './components/ResendTicketsForm/ResendTicketsForm.css';
import RegisteredPassenger from './components/RegisteredPassenger/RegisteredPassenger.css';
import SubsidySuggestPopup from './components/SubsidySuggestPopup/SubsidySuggestPopup.css';
import SubsidyRejectPopup from './components/SubsidyRejectPopup/SubsidyRejectPopup.css';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import SeatMapControls from './components/SeatMap/Controls/Controls.css';
import AircraftPopup from './components/AircraftPopup/AircraftPopup.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import AdditionalServices from './components/AdditionalServices/AdditionalServices.css';
import InsurancePage from './components/InsurancePage/InsurancePage.css';
import BaseCheckbox from './components/BaseComponents/Checkbox/Checkbox.css';
import PaymentResult from './components/PaymentResult/PaymentResult.css';
import SpecialEquipment from './components/SpecialEquipment/SpecialEquipment.css';

const theme: EngineTheme = {
	AircraftPopup: {
		AircraftPopup: {
			flightClasses: Results.aircraftPopup__flightClasses,
			paper: AircraftPopup.paper
		}
	},
	Entities: {
		Payment: {
			redirectButton_success: PaymentResult.redirectButton_success
		}
	},
	FullscreenDialog: {
		FullscreenDialog: {
			close: Checkout.fullscreenDialog__close,
			header: Checkout.fullscreenDialog__header
		}
	},
	Insurance: {
		InsuranceStyles: {
			dialog__header: Insurance.header__container,
			header: Insurance.header,
			wrapper: Insurance.wrapper,
			dialog: Insurance.dialog,
			dialog__button_clear: Insurance.insurance__cancel,
			dialog__button_done: Insurance.insurance__confirm
		},
		InsuranceCardStyles: {
			insurance: Insurance.card,
			selected: Insurance.card_selected,
			insurance__header: Insurance.card__header,
			insurance__money: Insurance.card__price,
			insurance__button: Insurance.card__button,
			insurance__button_selected: Insurance.card__button_selected
		}
	},
	Segment: {
		SegmentCommon: {
			airline__name: Checkin.segmentCommon__airlineName,
			wrapper: Checkin.segmentCommon__wrapper,
			flightInfo__title: Checkin.segmentCommon__flightInfo__title,
			city__airport: Checkin.segmentCommon__city__airport,
			footer: Checkin.segmentCommon__footer,
			footer__item: Checkin.segmentCommon__footerItem
		}
	},
	SelectedPassenger: {
		SelectedPassenger: {
			passengerInfo: Checkin.passengerInfo,
			passengerInfo__item: Checkin.passengerInfo__item,
			wrapper: Checkin.selectedPassenger__wrapper,
			loyalty__link: Checkin.loyaltyLink
		},
		LoyaltyNumber: {
			container: Checkout.loyaltyNumberContainer,
			button: Checkin.loyaltyNumber__button
		}
	},
	SelectedFare: {
		SelectedFare: {
			link: DesktopFlightModalContent.selectedFare__link
		}
	},
	SpecialEquipment: {
		SpecialEquipment: {
			card__icon: SpecialEquipment.card__icon
		}
	},
	DesktopFlightModalContent: {},
	CompareFares: {
		Content: {
			groupTitle: CompareFares.groupTitle,
			tableRow: Results.compareFares__tableRow
		},
		Cell: {
			cell_notFullFareConditions: CompareFares.compareFares_cellNotFullFareConditions,
			availabilityIcon: CompareFares.availabilityIcon
		},
		Fare: {
			fareHeadingItem__serviceClass: CompareFares.serviceClass,
			fareHeadingItem: CompareFares.fareHead
		},
		FaresSlider: {
			title: Results.compareFares__tableTitle
		}
	},
	FlightCard: {
		FlightCard: {
			info: DesktopFlightModalContent.flightCard__infoIcon,
			flight: DesktopFlightModalContent.flightCard__flight,
			flight__block: DesktopFlightModalContent.flightCard__flightBlock,
			flight__title: DesktopFlightModalContent.flightCard__flightTitle,
			airline: DesktopFlightModalContent.flightCard__airline,
			airline__logo: DesktopFlightModalContent.flightCard__airlineLogo,
			airline__number: DesktopFlightModalContent.flightCard__airlineNumber,
			footer: DesktopFlightModalContent.flightCard__footer,
			flight__value: DesktopFlightModalContent.flightCard__flightValue,
			aircraft__name: DesktopFlightModalContent.flightCard__flightName,
			airline__name: DesktopFlightModalContent.flightCard__airlineName,
			wrapper: DesktopFlightModalContent.flightCard__wrapper,
			amenities: DesktopFlightModalContent.flightCard__amenities
		}
	},
	PromoLoader: {
		PromoLoader: {
			wrapper: PromoLoader.wrapper,
			promo__content: PromoLoader.content,
			promo__image: PromoLoader.promoImage
		}
	},
	OrderCard: {
		OrderCard: {
			container: OrderCard.orderCard_container,
			type_review: OrderCard.orderCard_typeReview,
			buttons: OrderCard.orderCard_buttons
		},
		CommonItem: {
			root: OrderCard.commonItem_root
		},
		OrderStatus: {
			root: OrderCard.orderStatus_root,
			type_review: OrderCard.orderStatus_typeReview,
			confirmed: OrderCard.orderStatus_confirmed,
			transactions: OrderCard.orderStatus_transactions
		},
		OrderPassengers: {
			control: OrderCard.orderPassengers_control
		},
		PassengersModal: {
			passengers_wrapper: OrderCard.passengersModal_passengersWrapper
		},
		OrderPreview: {
			root: OrderCard.orderPreview__root
		}
	},
	Exchange: {
		Dialog: {
			paper: Baggage.container
		},
		SelectedFlights: {
			price: Exare.selectedFlights__price,
			charge__money: Exare.exchange__chargeMoney,
			change: Exare.exchange__changeSelectedTrigger,
			flight__container: Exare.exchange__flightContainer,
			header: Exare.exchange__header,
			header__name: Exare.exchange__SelectedFlightsHeaderName,
			charge: Exare.exchange__charge,
			total: Exare.selectedFlights__total,
			total__money: Exare.selectedFlights__totalMoney
		},
		RequestControls: {
			refuse: Exare.exchange_rejectButton,
			button: Exare.exchange__requestControlsButton
		},
		CreateRequest: {
			container: Exare.exchange__createRequestContainer,
			submit: Exare.exchange__submit,
			button: Exare.exchange__checkbox,
			button_checked: Exare.active
		},
		SearchFlights: {
			route: Exare.exchange__searchFlights__route,
			leg: Exare.exchange__leg,
			header: Exare.exchange__flightIcon,
			resultsError: Exare.exchange_resultsError
		},
		Calendar: {
			modal: Exare.exchange__calendar_modal,
			day_highlight: Exare.exchange__day_highlight,
			calendar: Exare.exchange__calendarTrigger,
			monthsWrapper__wrapper: Exare.monthsWrapperStyles_wrapper
		},
		Chip: {
			close: Exare.chip__close,
			chip: Exare.chip__chip
		},
		Inner: {
			exchange: Exare.exchange__inner
		},
		CommonSelect: {
			header: Exare.commonSelect__header,
			icon: Exare.exchange__stepIcon,
			buttons: Exare.exchange__buttons,
			back: Exare.exchange__button_back,
			button: Exare.exchange__button
		},
		Choice: {
			container: Exare.choiceContainer,
			label: Exare.exchange__label,
			label_selected: Exare.active,
			button: Exare.exchange__choice,
			button_checked: Exare.active
		},
		Datepicker: {
			wrapper: Exare.datepicker__wrapper
		},
		RequestForm: {
			header: Exare.title,
			created: Exare.time
		}
	},
	Refund: {
		MobileStep: {
			header: Exare.mobileStep__header
		},
		RequestForm: {
			checkbox: Exare.requestForm__checkbox,
			active: Exare.requestForm_active
		},
		Breadcrumbs: {
			breadcrumb: Exare.breadcrumbs__breadcrumb,
			close: Exare.breadcrumbs__close
		},
		Ticket: {
			reject: Exare.rejectButton,
			buttons: Exare.buttons,
			title: Exare.title
		},
		AddFile: {
			addIcon: Exare.addFileIcon
		},
		Passenger: {
			checkbox: Exare.checkbox,
			passenger: Exare.passenger__passenger,
			label: Exare.passenger__label,
			active: Exare.active
		},
		Reason: {
			radio: Exare.radio,
			active: Exare.active,
			label: Exare.reason
		},
		StepsButtons: {
			wrapper: Exare.refundButtons
		},
		StepTitle: {
			icon: Exare.stepTitle__icon
		},
		Refund: {
			buttons: Exare.refundButtons,
			prices: Exare.refund__prices
		}
	},
	Modal: {
		Modal: {
			scrollBody: Baggage.scrollBody,
			closeIcon: cn(Baggage.modal__closeBtn, Modal.closeIcon)
		}
	},
	BaggageService: {
		BaggageModal: {
			modal: Baggage.baggageModal
		},
		OverweightHeader: {
			title: Baggage.overweightHeader__title
		},
		TriggerControls: {
			controls: Baggage.trigger__controls,
			button: Baggage.trigger__controlsButton
		},
		TriggerDescription: {
			title: Baggage.triggerDescription__title,
			description: Baggage.triggerDescription__descr
		},
		Trigger: {
			servicePreview: Baggage.trigger__servicePreview,
			hasServices: Baggage.hasServices,
			trigger: Baggage.trigger,
			count: Baggage.trigger__count,
			button: Baggage.trigger__button
		},
		Controls: {
			button: Baggage.controls__button,
			cancel: Baggage.controls__button_cancel
		},
		BaggageServiceStyles: {
			baggage: Baggage.baggage,
			carryon: Baggage.carryon,
			baggage_full: Baggage.baggageService_full,
			services: Baggage.baggageService__services,
			grid: Baggage.baggage__pageWrp
		}
	},
	Inner: {
		Inner: {
			inner: Inner.inner
		}
	},
	PromoCode: {
		PromoCode: {
			trigger: SearchForm.promoCode_trigger,
			promoCode: SearchForm.promoCode,
			clear: SearchForm.promoCode__clear,
			modal: SearchForm.promoCode_modal
		}
	},
	Counter: {
		Counter: {
			button_disabled: Baggage.disabled,
			button: cn(Counter.button, Baggage.baggage__counter)
		}
	},
	Button: {
		Button: {
			button_text: Checkout.button_text,
			button_outline: cn(Exare.exchange__outline, Checkin.button__button_outline)
		},
		ActionButton: {
			button: cn(ActionButton.button, Exare.actionButton)
		},
		WhiteButton: {
			button: ActionButton.white
		}
	},
	MealService: {
		List: {
			item: Meal.categories__item,
			item_selected: Meal.active,
			item__icon: Meal.icon
		}
	},
	Meal: {
		Meal: {
			meal: Meal.meal,
			price: Meal.price
		},
		Details: {
			trigger: Meal.details__trigger,
			passenger: Meal.details__passenger,
			addForAll: Meal.details__addForAll,
			clear: Meal.details__clear
		}
	},
	Results: {
		Sortings: {
			currentSorting: Results.sortings__title
		},
		FlightsList: {
			wrapper: Results.flightsList,
			wrapper_return: Results.flightsList__wrapper_return
		},
		Disclaimer: {
			wrapper: Results.disclaimer
		},
		Results: {
			header: Results.header,
			results: Results.results,
			inner: Results.inner,
			outer_bottom: Results.outer,
			messages: Results.messages,
			toolbar__backButton: Results.toolbar__backButton
		},
		OtherDates: {
			container: Results.otherDates__container,
			text: Results.otherDates__text
		},
		Calendar: {
			legNumber: Results.calendar__legNumber,
			title__text: Results.calendar__titleText,
			header: Results.calendarHeader,
			calendar: Results.calendar,
			tabs: Results.calendarTabs
		},
		SelectedFares: {
			wrapper: Results.selectedFares__wrapper,
			flight: Results.selectedSegment,
			flight_selected: Results.flight_selected
		}
	},
	QuickSearchForm: {
		Summary: {
			route: Results.summary__route,
			passengers: cn(Results.summary__passengers, QuickSearchForm.passengers),
			summary: QuickSearchForm.summary,
			dates: Results.summary__dates
		},
		QuickSearchForm: {
			form: Results.quickSearchForm__form
		}
	},
	Amenities: {
		Amenities: {
			amenities__item_unavailable: Results.amenities__item_unavailable,
			amenities__item: Results.amenities__item
		}
	},
	MobileSelectedFare: {
		MobileSelectedFareStyles: {
			selectedFare: Results.mobileSelectedFare__root,
			feature__icon: Results.mobileSelectedFare__featureIcon,
			features__info: Results.mobileSelectedFare__featuresInfo,
			dialog__header: MobileSelectedFare.dialog__header
		}
	},
	MobileFlight: {
		FlightStyles: {
			segments: Results.flight__segments,
			flight: Results.flight__flight,
			segment: Results.flight__segment,
			price: Results.flight__price,
			price__text: Results.flight__price__text,
			price__money: Results.flight__price__money
		}
	},
	MobileSummaryFlight: {
		MobileSummaryFlight: {
			footer__price_flat: Results.mobileSummaryFLight__price_flat,
			footer_flat: Results.mobileSummaryFLight__footer_flat
		}
	},
	MobileSegmentInfo: {
		MobileSegmentFlat: {
			transferCount: Results.mobileSegmentFlat__transferCount,
			icons: Results.mobileSegmentFlat__icons,
			aircraftName: Results.mobileSegmentFlat__aircraftName,
			duration__text: Results.segment__flightDuration__text,
			duration__point: Results.segment__flightDurationPoint,
			duration: Results.segment__flightDuration,
			duration__wrapper: Results.mobileSegmentFlat_durationWrapper,
			flightNumber__route: Results.segment__flightNumber,
			totalDuration: Results.totalDuration
			// image: Results.image
		},
		MobileSegmentInfo: {
			statistics: MobileSegmentInfo.statistics
		}
	},
	FareGroup: {
		FareGroup: {
			keyFeature__value: Results.fareGroup__keyFeatureValue,
			option: Results.fareGroup__option,
			option_unavailable: Results.fareGroup__option_unavailable,
			option__icon: Results.fareGroup__optionIcon,
			option__title: Results.fareGroup__optionTitle,
			option__value: Results.fareGroup__optionValue,
			fareGroup_white: Results.fareGroup_white,
			keyFeature: Results.fareGroup__keyFeature,
			keyFeature_paid: Results.fareGroup__keyFeature_paid,
			keyFeature__icon: Results.fareGroup__keyFeatureIcon,
			upgradeOffer: Results.fareGroup__upgradeOffer,
			info: Results.fareGroup__info,
			fareGroup_recommended: Results.fareGroup_recommended
		},
		RecommendedBadge: {
			badge: Results.recommendedBadge,
			wrapper: Results.fareGroup__recommendedWrapper
		}
	},
	DesktopFlight: {
		DesktopFlightPopup: {
			scrollBody: Results.desktopFlightModal__scrollBody,
			paper: Results.desktopFlightModal__closeButton,
			paper_select: Results.desktopFlightModal__paperSelect
		},
		ModalContent: {
			pagination__index: Results.desktopFlightModal__paginationIndex,
			paper: Results.desktopFlightModal__paper,
			fareGroup_stub: Results.desktopFlightModal__fareGroupStub,
			close_icon: Results.desktopFlightModal__closeIcon,
			compareFaresLink: Results.desktopFlightModal__compareFaresLink,
			compareFaresLink_icon: Results.desktopFlightModal__compareFaresLinkIcon,
			scroll_up: Results.desktopFlightModal__scrollUp,
			slider__wrp: DesktopFlightModalContent.slider__wrp
		},
		Location: {
			time: Results.desktopFlightModal__locationTime,
			time_iata: Results.desktopFlightModal__locationTimeIata,
			date: Results.desktopFlightModal__locationDate,
			date_icon: Results.desktopFlightModal__locationDateIcon,
			city: Results.desktopFlightModal__locationCity,
			terminal: Results.desktopFlightModal__locationTerminal
		},
		DesktopFlightModalHeader: {
			title: Results.desktopFlightModalHeader__title
		},
		DesktopFlightModalContentSelected: {
			flight: Results.desktopFlightModal__fareSelected
		},
		SelectedFareGroup: {
			button: Results.selectedFareGroup
		}
	},
	DesktopFlightRoute: {
		DesktopFlightRouteStyles: {
			flight: cn(Results.desktopFlightRoute__flight, Checkout.selectedFlight)
		},
		FlightPriceStyles: {
			fare_family: Results.flightPrice__fareFamily,
			best: Results.flightPrice__best,
			price_single: Results.flightPrice_single,
			selectFrom_best: Results.flightPrice__selectFrom,
			price: Results.flightPrice__price,
			price_selected: Results.flightPrice__price_selected,
			price__money: Results.flightPrice__money,
			button: Results.flightPrice__button,
			clear: Results.flightPrice__clear
		},
		SingleFlightSegment: {
			aircraft: Results.singleFlightSegment__aircraft,
			route: Results.route,
			flightNumber: Results.singleFlightSegment__flightNumber,
			stop: Results.singleFlightSegment__stop,
			totalDuration: Results.singleFlightSegment__totalDuration,
			info__aircraft: Results.singleFlightSegment__aircraftName,
			flightIcon: Results.singleFlightSegment_flightIcon
		},
		RouteArrowStyles: {
			route: Results.route__arrow,
			timeInRoute: Results.route__timeInRoute,
			circle: Results.route__circle,
			container: Results.routeArrow__container,
			flightNumber: Results.routeArrow__flightNumber
		},
		PointStyles: {
			point: Results.point,
			airport__iata: Results.point__iata,
			date: Results.point__date,
			date__container: Results.point__dateContainer,
			stop: Results.point__stop,
			time: Results.point__time,
			airport: Results.point__airport
		},
		SegmentStyles: {
			plane: cn(Results.segment__aircraft, Checkout.segment__aircraft),
			planeInfo: Results.segment__planeInfo,
			segment: Results.segment,
			flightInfo__date: Results.segment__date,
			flightInfo__airline: Results.segment__flightInfo__airline,
			route__info: Results.segmentStyles_routeInfo,
			flightInfo__nextDay: Results.segment__flightInfo__nextDay,
			totalDuration: Results.segment__totalDuration,
			aircraft: Results.segment__aircraft
		},
		StopsInfoStyles: {
			stop: Results.stopsInfo__stop
		}
	},
	Autocomplete: {
		Autocomplete: {
			input_focused: Checkout.focused,
			input: Checkout.input,
			label_shrink: Checkout.focused,
			autocomplete__root: Checkout.label,
			options: SearchForm.options
		}
	},
	Datepicker: {
		MonthHeaderStyles: {
			monthHeader: SearchForm.datepicker__monthHeader
		},
		DayStyles: {
			day_weekend: SearchForm.weekend,
			day_inPeriod: SearchForm.inPeriod,
			day_endPeriod: SearchForm.endPeriod,
			day_startPeriod: SearchForm.startPeriod,
			day: SearchForm.day,
			day_today: SearchForm.today,
			day_notAvailable: SearchForm.notAvailable
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			content: SearchForm.datepicker__content,
			progress__color: SearchForm.datepicker__progress,
			inputWrapper: SearchForm.datepicker__inputWrapper,
			popup: SearchForm.datepicker__popup,
			footer: SearchForm.datepicker__footer,
			datepicker__disclaimer: SearchForm.datepicker__disclaimer
		},
		DayStyles: {
			day_hasPrice: SearchForm.hasPrice,
			day_selected: SearchForm.selected,
			day__price: SearchForm.day__price,
			day_withPrice: SearchForm.withPrice
		}
	},
	SearchForm: {
		Datepicker: {
			alternative_dow: SearchForm.datepicker__dow,
			highlightedDate_withPrice: SearchForm.withPrice,
			dates: SearchForm.datepicker__dates,
			placeholder: SearchForm.datepicker__placeholder,
			dates_focused: SearchForm.focused,
			returnDelete: SearchForm.clear,
			dates__to: SearchForm.datepicker__dates_to,
			dates__back: SearchForm.datepicker__dates_back,
			dates__to_focused: SearchForm.focused,
			dates__back_focused: SearchForm.focused,
			placeholder_icon: SearchForm.datepicker_placeholderIcon,
			alternative: SearchForm.datepicker_alternative,
			dow: SearchForm.datepicker_dow,
			dates__to_text: SearchForm.datepicker_datesToText,
			date__toIcon: SearchForm.datepicker_toIcon,
			placeholder_text: SearchForm.datepicker_placeholderText,
			dates__icon: SearchForm.datepicker__dates__icon
		},
		Passengers: {
			arrowIcon: SearchForm.passengers__arrow,
			title: SearchForm.passengers__title,
			mobileTitle: SearchForm.passengers__mobileTitle,
			passengers: SearchForm.passengers,
			selector_focused: SearchForm.focused,
			selector: SearchForm.passengers__trigger,
			age: SearchForm.passengers__age,
			info__icon: SearchForm.passengers__infoIcon,
			counter: SearchForm.passengers__counter,
			increase: SearchForm.passengers__increase,
			decrease: SearchForm.passengers__decrease,
			passengers_isMultiCity: SearchForm.passengers_isMultyCity
		},
		StartSearch: {
			startSearch: SearchForm.startSearch,
			startSearch_iconMode: SearchForm.startSearch_iconMode,
			startSearch_multiCity: SearchForm.multiCity
		},
		Value: {
			wrapper: SearchForm.value__wrapper,
			code: SearchForm.value__code,
			value: cn(SearchForm.value, SearchForm.value__value)
		},
		Controls: {
			controls: SearchForm.controls,
			controls_multiCity: SearchForm.controls_multyCity
		},
		Segments: {
			segments: SearchForm.segments,
			segments_multiCity: SearchForm.segments_multiCity
		},
		SearchForm: {
			searchForm: SearchForm.searchForm,
			row: SearchForm.row
		},
		Segment: {
			segment: SearchForm.segment,
			wrapper: SearchForm.segmentWrapper,
			cell: SearchForm.segmentCell,
			cell_date: SearchForm.segmentCell_date,
			remover: SearchForm.segment_remover,
			input: SearchForm.segment_input,
			withMultiCity: SearchForm.segment_withMultiCity,
			cell_location: SearchForm.segment_cellLocation,
			input_text: SearchForm.segment_inputText
		},
		Location: {
			switcher: SearchForm.switcher,
			switcher_highlighted: SearchForm.active,
			autocomplete: SearchForm.autocomplete,
			location: SearchForm.location,
			input: SearchForm.location__input,
			input_withoutPlaceholder: SearchForm.withoutPlaceholder,
			input_icon: SearchForm.location_inputIcon
		},
		MultiCity: {
			caption: SearchForm.miltyCity_caption
		},
		Bottom: {
			bottom: SearchForm.botton_bottom,
			controls: SearchForm.bottom__controls
		},
		Actions: {
			actions_alternative: SearchForm.actions_actionsAlternative,
			addSegment: SearchForm.actions_addSegment,
			removeSegment: SearchForm.action_removeSegment
		},
		PromoCode: {
			promoCode: SearchForm.promoCode_wrapper
		},
		SearchFormSwitch: {
			label: SearchForm.searchFormSwitch__label
		}
	},
	Passengers: {
		PassengerStyles: {
			age: SearchForm.passengers__age,
			info__icon: SearchForm.passengers__infoIcon,
			counter: SearchForm.passengers__counter,
			increase: SearchForm.passengers__increase,
			decrease: SearchForm.passengers__decrease
		},
		PassengersStyles: {
			item: SearchForm.passenger__item,
			item_FNN: SearchForm.passenger__item_FNN
		}
	},
	MobileStepbar: {
		MobileStepbarStyles: {
			collapse: Stepbar.collapse,
			price: Stepbar.price
		},
		StepStyles: {
			step: Stepbar.step,
			price__expand: Stepbar.expand,
			name__label: Stepbar.step__nameLabel,
			step__price: Stepbar.step__innerPrice,
			step_disabled: Stepbar.disabled,
			name__index: Stepbar.step__nameIndex
		},
		StepContentStyles: {
			segment__header_baggage: Stepbar.stepContent__segmentHeaderBaggage,
			wrapper: Stepbar.stepContent__wrapper,
			footer: Stepbar.stepContent__footer,
			price__money: Stepbar.stepContent__segmentMoney,
			segment__price: Stepbar.stepContent__segmentPrice,
			segment__header_flights: Stepbar.stepContent__headerText_flights,
			header__text: Stepbar.stepContent__headerText,
			content__icon: Stepbar.stepContent__contentIcon
		}
	},
	MobileSegment: {
		MobileSegment: {
			fareGroup: Checkin.mobileSegment__fareGroup,
			fareGroup__info: Checkin.mobileSegment__fareGroupInfo,
			wrapper: Checkin.mobileSegment__wrapper
		}
	},
	Input: {
		Input: {
			real_input: Checkout.input,
			label_shrink: Checkout.focused,
			input: Checkout.input,
			textField__root: Checkout.label,
			input_focused: Checkout.focused,
			disabled: Checkout.disabled
		}
	},
	Contacts: {
		ContactsStyles: {
			description__text: Checkout.contacts__descrText,
			field__contact: Checkout.contactsField,
			fields: Checkout.contacts__fields,
			footer__inner: Checkout.footer__inner
		}
	},
	Passenger: {
		PassengerSwitch: {
			element: Checkout.switchElement,
			element_active: Checkout.active
		},
		PassengerStyles: {
			form_citizenship: Checkout.passengersForm__citizenship,
			form_identy: Checkout.passengersForm__identity,
			form__container: Checkout.passengersForm__container,
			form_other: Checkout.passengersForm__formOther,
			group__title: Checkout.passengersForm__groupTitle
		}
	},
	SelectableSegment: {
		SelectableSegmentDesktop: {
			airplane: Checkin.selectSegmentsModal__airplane
		}
	},
	Checkin: {
		Conditions: {
			container: Checkin.conditions__container
		},
		SelectSegmentsModal: {
			dialogRoot: Checkin.selectSegmentsModal,
			header: Checkin.selectSegmentsModal__header,
			button: Checkin.selectSegmentsModal__button
		},
		Inital: {
			wrapper: Checkin.initial__wrapper
		},
		CheckinErrorBoundary: {
			active: Checkin.checkinErrorBoundary__button_active
		},
		Passengers: {
			toolbar__button: Checkin.passengers__toolbarButton,
			wrapper: Checkin.passengers__wrapper
		}
	},
	Checkout: {
		GroupOrder: {
			passenger: Checkout.groupOrder__passenger,
			addPassenger: Checkout.groupOrder__addPassenger,
			addIcon: Checkout.groupOrder__addIcon,
			checkboxColor: Checkout.groupOrder__checkboxColor,
			checked: Checkout.groupOrder__checked
		},
		OrderPaidServiceCards: {
			meal__dialogContent: Checkout.orderPaidServiceCards__mealDialogContent
		},
		ThanksBanner: {
			wrapper: Checkout.thanksBanner__wrapper
		},
		CheckoutStyles: {
			fareLockWrapper: Checkout.fareLockWrapper,
			selectedFlight__container: Checkout.selectedFlight__container,
			checkoutServices: Checkout.checkout__checkoutServices,
			checkout: Checkout.checkout,
			desktopFlight__flight: Checkout.summaryFlights,
			container: Checkout.container,
			orderControlBtn: Checkout.orderCtrlButton,
			mobileToolbar: Checkout.checkout__mobileToolbar,
			timelimit: Checkout.timelimit,
			paidOrderWrapper: Checkout.paidOrderWrapper,
			summary__wrp: Checkout.summary__wrp,
			messages_htmlClassName: Checkout.messages_htmlClassName
		},
		PassengersToolbar: {
			checkbox: Toolbar.checkbox,
			checkbox_checked: Toolbar.checked,
			root: PassengerToolbarAdditional.root,
			label: PassengerToolbarAdditional.label
		},
		Stepbar: {
			additional: Stepbar.additional
		},
		PassengersConsents: {
			container: Checkout.passengersConsents__container
		}
	},
	Toolbar: {
		Toolbar: {
			button: Toolbar.button,
			backButton__wrapper: Toolbar.backButton__wrapper,
			backButton: Toolbar.backButton,
			price: Toolbar.price
		}
	},
	BaggageTotalPriceBlock: {
		BaggageTotalPriceBlock: {
			price: Baggage.baggage__price
		}
	},
	RetrieveBooking: {
		RetrieveBooking: {
			form: Checkout.retrieveBooking__form,
			container_checkin: Checkin.retrieveBooking__container,
			title: Checkin.retrieveBooking__title
		}
	},
	AdditionalBaggage: {
		AdditionalModalHeaderMobile: {
			icon: Baggage.additionalModalHeaderMobile__icon,
			service: Baggage.additionalModalHeaderMobile__service,
			service__active: Baggage.active,
			service_price: Baggage.additionalModalHeaderMobile__price
		},
		PromoMessage: {
			root: Baggage.baggage__promoMessageRoot
		},
		AdditionalModalFooter: {
			label: Baggage.baggage__differentTrigger,
			switchCls: Baggage.switchCls,
			confirm_btn: Baggage.confirm,
			cancel_btn: Baggage.cancel,
			clear: Baggage.baggage__clear
		},
		AdditionalBaggage: {
			root: cn(Baggage.additionalBaggage__root, AdditionalBaggage.root),
			footer: Baggage.additionalBaggage__footer
		},
		AdditionalModal: {
			first_column: Baggage.additionalModal__firstColumn,
			root: Baggage.baggage__additionalModal
		},
		AdditionalModalHeaderDesktop: {
			price: Baggage.baggage__price
		}
	},
	Baggage: {
		BaggageIcon: {
			root: cn(Baggage.baggage__icon, BaggageIcon.root),
			value: BaggageIcon.value,
			measurement: BaggageIcon.measurement,
			wrapper: cn(BaggageIcon.wrapper, Baggage.baggageIcon_wrapper),
			carry_on: BaggageIcon.carry_on,
			hand_luggage_excess: Baggage.hand_luggage_excess
		},
		Baggage: {
			name: Baggage.baggage__name,
			size: Baggage.baggage__size,
			icon: Baggage.baggageIcon
		}
	},
	BaggageList: {
		BaggageList: {
			add: Baggage.baggageList__add
		},
		BaggageCount: {
			root: Baggage.baggage__count
		},
		BaggageDirection: {
			root: BaggageDirection.root
		}
	},
	Link: {
		Link: {
			link: Link.link
		}
	},
	SuggestionModalContent: {
		SuggestionModalContent: {
			modal__content: SeatMap.suggestionModal__content
		}
	},
	SeatMap: {
		SeatsInfoStyles: {
			price__wrapper: SeatMap.seatsInfo__priceWrp
		},
		AirplaneStyles: {
			seatsDetails: SeatMap.seatDetails,
			airplane: SeatMap.airplane
		},
		SeatMapStyles: {
			row__serviceHeader__wrapper: SeatMap.service__header
		},
		SeatStyles: {
			seat: SeatMap.seat,
			number: SeatMap.seat__number,
			seatPrice: SeatMap.seat__price,
			seat_withZeroPrice: SeatMap.seat_withZeroPrice,
			extendedIcon: SeatMap.seat__extendedIcon,
			seat_recommendCurrent: SeatMap.seat_recommend_current,
			seat_recommend: SeatMap.seat_recommend,
			seat_business: SeatMap.seat_business,
			seat_occupied: SeatMap.seat_occupied
		},
		SeatTooltipStyles: {
			popper: SeatMap.tooltip_popper,
			tooltip: SeatMap.tooltip,
			info: SeatMap.info,
			tooltip_withInfo: SeatMap.tooltip_withInfo,
			tooltip_recommend: SeatMap.tooltip_recommend,
			container: SeatMap.container,
			details: SeatMap.details
		},
		Passenger: {
			item: SeatMap.passenger,
			item_active: SeatMap.passenger_active,
			avatar: SeatMap.passenger__number,
			passengerName: SeatMap.passenger__name,
			item_withSeat: SeatMap.passenger_withSeat,
			item_recommend: SeatMap.passenger_recommend,
			payload: SeatMap.passenger__payload,
			money: SeatMap.passenger__price,
			select: SeatMap.passenger__select,
			selectMobile: SeatMap.passenger__selectMobile,
			selectMobile_selected: SeatMap.passenger__selectMobile_selected,
			seat: SeatMap.passenger__seat,
			main: SeatMap.passenger__main
		},
		PassengersStyles: {
			recommend: SeatMap.recommend,
			recommend__icon: SeatMap.recommend__icon,
			passengers__button_clear: SeatMap.clear,
			passengers__button: SeatMap.confirm,
			recommend__wrapper: SeatMap.recommend__wrapper,
			passengers: SeatMap.seatmap_passengers_recommend,
			passengers__footer: SeatMap.seatmap_passengers_footer
		},
		Controls: {
			button: cn(SeatMapControls.button, SeatMap.confirm)
		},
		MobilePassenger: {
			passenger: SeatMap.mobilePassenger
		}
	},
	PaymentTimeLimit: {
		PaymentTimeLimitPage: {
			text: PaymentTimeLimit.text
		}
	},
	CheckoutAdditionalService: {
		CheckoutAdditionalService: {
			service: CheckoutAdditionalService.service,
			service_active: CheckoutAdditionalService.service_active,
			header: CheckoutAdditionalService.header,
			header__price: CheckoutAdditionalService.header__price,
			header__text: CheckoutAdditionalService.header__text,
			content: CheckoutAdditionalService.content
		},
		Seats: {
			seats: Checkout.checkoutAdditionalService_seats
		},
		Business: {
			business: CheckoutAdditionalService.business,
			paper: CheckoutAdditionalService.paper,
			header: CheckoutAdditionalService.business__header
		},
		PriorityBoarding: {
			priority: CheckoutAdditionalService.priority,
			header: CheckoutAdditionalService.priority__header,
			paper: CheckoutAdditionalService.paper
		},
		InsuranceUpsale: {
			container: InsurancePage.insuranceUpsale__container,
			container_selected: InsurancePage.insuranceUpsale__containerSelected,
			header: InsurancePage.insuranceUpsale__header,
			footer: InsurancePage.insuranceUpsale__footer,
			info: InsurancePage.insuranceUpsale__info,
			content: InsurancePage.insuranceUpsale__content,
			label: InsurancePage.insuranceUpsale__label,
			price: InsurancePage.insuranceUpsale__price,
			price__label: InsurancePage.insuranceUpsale__priceLabel,
			oldVersion: InsurancePage.oldVersion
		},
		Insurance: {
			insurance: CheckoutAdditionalService.insurance,
			service_active: CheckoutAdditionalService.service_active,
			serviceWrapperEndAdornment: CheckoutAdditionalService.serviceWrapperEndAdornment
		}
	},
	SimpleLoader: {
		SimpleLoaderStyles: {
			wrapper: Baggage.simpleLoader
		}
	},
	Warnings: {
		WarningsStyles: {
			wrapper: Baggage.icon__text
		}
	},
	Location: {
		Location: {
			footer: SearchForm.location__footer
		}
	},
	PaymentForm: {
		PaymentForm: {
			card: PaymentForm.card,
			sbp: PaymentForm.sbp
		},
		Gateway: {
			header__arrow: Payment.gateway_headerArrow
		},
		Card: {
			iframe: Payment.iframe
		}
	},
	FareConditions: {
		FareConditions: {
			paperRoot: FareConditions.paperRoot,
			heading: FareConditions.heading,
			tab: FareConditions.tab,
			tab_active: FareConditions.tab_active,
			tabIndicator: FareConditions.tabIndicator,
			fareConditionsSegmentHeading__inner: FareConditions.fareConditionsSegmentHeading__inner,
			fareConditionsSegmentFareCode: FareConditions.fareConditionsSegmentFareCode,
			fareConditionsContent: FareConditions.fareConditionsContent
		}
	},
	Notification: {
		Notification: {
			context: Notification.context,
			info: Notification.info,
			icon: cn(Notification.icon, SubsidyRejectPopup.icon),
			title: Notification.title,
			text: cn(Notification.text, SubsidySuggestPopup.text, SubsidyRejectPopup.text),
			content: Notification.content,
			action: Notification.action,
			warning: Notification.warning
		}
	},
	FareLock: {
		FareLock: {
			root: cn(Results.fareLock__root, Checkout.fareLock__root)
		},
		DescriptionBlock: {
			root: Results.descriptionBlock__root,
			root_refund: Results.descriptionBlock__root_refund,
			iconWrapper: Results.descriptionBlock__iconWrapper,
			title: Results.descriptionBlock__title,
			rules: Results.descriptionBlock__rules
		},
		SwitchBlock: {
			root: Results.switchBlock__root,
			root_refund: Results.switchBlock__root__refund
		}
	},
	AdditionalServiceBanner: {
		AdditionalServiceBannerStyles: {
			baggageBanner: AdditionalServiceBanner.baggageBanner,
			text: AdditionalServiceBanner.text,
			disclaimer: AdditionalServiceBanner.disclaimer,
			disclaimer__icon: AdditionalServiceBanner.disclaimer__icon,
			image: AdditionalServiceBanner.image
		}
	},
	IncludedBaggage: {
		IncludedBaggage: {
			root: IncludedBaggage.root,
			header: IncludedBaggage.header,
			included_block: Baggage.includedBaggage__included_block,
			body: Baggage.includedBaggage__body
		}
	},
	UpgradeBaggageDialog: {
		BaggageFooter: {
			root: Baggage.baggageFooter__root
		},
		HeaderEquipmentItem: {
			wrapper: Baggage.headerEquipmentItem__wrapper
		}
	},
	BaggagePage: {
		BaggagePage: {
			newBaggage: Baggage.baggagePage_newBaggage,
			items: Baggage.items
		}
	},
	BaggageCard: {
		BaggageCard: {
			button: BaggageCard.button,
			icon: BaggageCard.icon,
			description: BaggageCard.description
		}
	},
	ResendTicketsForm: {
		ResendTicketsForm: {
			input: ResendTicketsForm.resendTicketsForm__input,
			input_underline: ResendTicketsForm.resendTicketsForm__inputUnderline
		}
	},
	RegisteredPassenger: {
		RegisteredPassenger: {
			downloadButton: RegisteredPassenger.registeredPassenger__downloadButton
		}
	},
	SubsidySuggestPopup: {
		SubsidySuggestPopup: {
			container: SubsidySuggestPopup.container,
			header__text: SubsidySuggestPopup.header__text,
			description: SubsidySuggestPopup.description,
			passengerType: SubsidySuggestPopup.passengerType,
			age: SubsidySuggestPopup.age,
			info__icon: SubsidySuggestPopup.info__icon,
			passengers: SubsidySuggestPopup.passengers,
			item: SubsidySuggestPopup.item,
			increase: SubsidySuggestPopup.increase,
			decrease: SubsidySuggestPopup.decrease,
			counter: SubsidySuggestPopup.counter,
			notification: SubsidySuggestPopup.notification,
			buttons: SubsidySuggestPopup.buttons,
			newSearch: SubsidySuggestPopup.newSearch,
			continueButton: SubsidySuggestPopup.continueButton
		}
	},
	SubsidyRejectPopup: {
		SubsidyRejectPopup: {
			container: SubsidyRejectPopup.container,
			header__text: SubsidyRejectPopup.header__text,
			flight: SubsidyRejectPopup.flight,
			passenger: SubsidyRejectPopup.passenger,
			notification: SubsidyRejectPopup.notification,
			buttons: SubsidyRejectPopup.buttons,
			newSearch: SubsidyRejectPopup.newSearch,
			continueButton: SubsidyRejectPopup.continueButton
		}
	},
	AdditionalServices: {
		Insurance: {
			scrollBody: AdditionalServices.insurance__scrollBody
		}
	},
	InsurancePage: {
		InsurancePrice: {
			link: InsurancePage.insurancePrice__link
		},
		InsuranceUpsaleModal: {
			root: InsurancePage.insuranceModal__root,
			button: InsurancePage.insuranceModal__button
		},
		InsuranceProduct: {
			moreInfo: InsurancePage.moreInfo,
			selectButton: InsurancePage.selectButton
		},
		SelectForm: {
			radio: InsurancePage.selectForm__radio,
			checked: InsurancePage.selectForm__checked
		},
		InsurancePage: {
			title: InsurancePage.title,
			header: InsurancePage.header,
			subheader: InsurancePage.subheader
		},
		InsurancePageModal: {
			footer: InsurancePage.insurancePageModal__footer,
			button: InsurancePage.insurancePageModal__button,
			button_cancel: InsurancePage.insurancePageModal__buttonCancel
		},
		InsuranceProductView: {
			root_insurance: InsurancePage.insuranceProductView__root_insurance,
			header: InsurancePage.insuranceProductView__header,
			content: InsurancePage.insuranceProductView__content,
			selectButton: InsurancePage.selectButton
		}
	},
	Cart: {
		Cart: {
			cart: Cart.cart
		}
	},
	BaseComponents: {
		Checkbox: {
			checkbox: BaseCheckbox.checkbox,
			checked: BaseCheckbox.checked,
			indeterminate: BaseCheckbox.indeterminate
		}
	},
	Features: {
		StartCheckIn: {
			AcceptCheckinRules: {
				rules: Checkin.rules
			}
		}
	}
};

export default theme;
